import React, { useState } from 'react'

const COUNTRIES = [
  { value: 'indonesia', label: 'Indonesia',  center: [-2.5, 118.0] },
  { value: 'kenya',     label: 'Kenya',      center: [0.0,  38.0]  },
  { value: 'vietnam',   label: 'Vietnam',    center: [16.0, 106.0] },
]

const RESOLUTIONS = [
  { value: 5,  label: '5 km (fine)' },
  { value: 10, label: '10 km (standard)' },
  { value: 20, label: '20 km (coarse)' },
  { value: 50, label: '50 km (overview)' },
]

export default function ScanControls({ onScan, onFlyTo, loading }) {
  const [country,     setCountry]     = useState('indonesia')
  const [technology,  setTechnology]  = useState('solar_pv')
  const [capacityMw,  setCapacityMw]  = useState(10)
  const [resolutionKm, setResolution] = useState(20)
  const [bbox, setBbox] = useState({ minLat: '', maxLat: '', minLon: '', maxLon: '' })

  const handleCountryChange = (e) => {
    const c = e.target.value
    setCountry(c)
    const info = COUNTRIES.find(x => x.value === c)
    if (info) onFlyTo(info.center)
  }

  const handleScan = () => {
    const params = {
      min_lat: Number(bbox.minLat),
      max_lat: Number(bbox.maxLat),
      min_lon: Number(bbox.minLon),
      max_lon: Number(bbox.maxLon),
      resolution_km: resolutionKm,
      technology,
      capacity_mw: capacityMw,
      country,
    }
    onScan(params)
  }

  const valid = bbox.minLat && bbox.maxLat && bbox.minLon && bbox.maxLon
    && Number(bbox.minLat) < Number(bbox.maxLat)
    && Number(bbox.minLon) < Number(bbox.maxLon)

  return (
    <div className="card">
      <div className="card__title">Area Scan</div>

      <div className="control-row">
        <div className="control-group">
          <label>Country preset</label>
          <select value={country} onChange={handleCountryChange}>
            {COUNTRIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
        </div>
        <div className="control-group">
          <label>Technology</label>
          <select value={technology} onChange={e => setTechnology(e.target.value)}>
            <option value="solar_pv">Solar PV</option>
            <option value="wind">Wind</option>
          </select>
        </div>
      </div>

      <div className="control-row">
        <div className="control-group">
          <label>Resolution</label>
          <select value={resolutionKm} onChange={e => setResolution(Number(e.target.value))}>
            {RESOLUTIONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
        </div>
        <div className="control-group">
          <label>Capacity (MW)</label>
          <select value={capacityMw} onChange={e => setCapacityMw(Number(e.target.value))}>
            {[5, 10, 20, 50, 100].map(v => <option key={v} value={v}>{v} MW</option>)}
          </select>
        </div>
      </div>

      <div style={{ fontSize: 11, color: 'var(--color-muted)', marginBottom: 6 }}>
        Bounding box (decimal degrees)
      </div>
      <div className="control-row">
        <div className="control-group">
          <label>Min lat</label>
          <input type="number" step="0.1" placeholder="-8.0"
            value={bbox.minLat} onChange={e => setBbox(b => ({ ...b, minLat: e.target.value }))} />
        </div>
        <div className="control-group">
          <label>Max lat</label>
          <input type="number" step="0.1" placeholder="-6.0"
            value={bbox.maxLat} onChange={e => setBbox(b => ({ ...b, maxLat: e.target.value }))} />
        </div>
      </div>
      <div className="control-row">
        <div className="control-group">
          <label>Min lon</label>
          <input type="number" step="0.1" placeholder="106.0"
            value={bbox.minLon} onChange={e => setBbox(b => ({ ...b, minLon: e.target.value }))} />
        </div>
        <div className="control-group">
          <label>Max lon</label>
          <input type="number" step="0.1" placeholder="108.0"
            value={bbox.maxLon} onChange={e => setBbox(b => ({ ...b, maxLon: e.target.value }))} />
        </div>
      </div>

      <button
        className="btn btn-primary"
        disabled={!valid || loading}
        onClick={handleScan}
        style={{ marginTop: 4 }}
      >
        {loading ? 'Scanning…' : 'Run Area Scan'}
      </button>
    </div>
  )
}
